const state = {
  dadosFornecedor: {
    fornecedor: ''
  }
}

const mutations = {
  setDadosFornecedor (state, obj) {
    state.dadosFornecedor = obj
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/fornecedor.js